<form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (submit)="onSubmit()">
  <h2>{{ 'content.about-subject' | translate }}</h2>
  <h3>{{ 'content.subject' | translate }}</h3>
  <app-hawk-sin-dob dobControlName="dob1" sinControlName="sin1" [displayErrors]="formSubmitted" [formGroup]="f"></app-hawk-sin-dob>

  <h3>{{ 'content.joint' | translate }}</h3>
  <app-hawk-sin-dob dobControlName="dob2" sinControlName="sin2" [displayErrors]="formSubmitted" [formGroup]="f"></app-hawk-sin-dob>

  <h3>{{ 'content.address.address' | translate }} 1</h3>
  <app-hawk-type [control]="addr1C.type" [displayErrors]="formSubmitted" [formGroup]="addr1F" [hawkTypes]="types"></app-hawk-type>
  <app-address-form [displayErrors]="formSubmitted" [formGroup]="addr1F"></app-address-form>
  <app-phone-form-row phoneFormControlName="phone" phoneNumberCssClass="col-md-4" [displayErrors]="formSubmitted" [formGroup]="addr1F"></app-phone-form-row>

  <h3>{{ 'content.address.address' | translate }} 2</h3>
  <app-hawk-type [control]="addr2C.type" [displayErrors]="formSubmitted" [formGroup]="addr2F" [hawkTypes]="types"></app-hawk-type>
  <app-address-form [displayErrors]="formSubmitted" [formGroup]="addr2F"></app-address-form>
  <app-phone-form-row phoneFormControlName="phone" phoneNumberCssClass="col-md-4" [displayErrors]="formSubmitted" [formGroup]="addr2F"></app-phone-form-row>

  <h3>{{ 'content.address.address' | translate }} 3</h3>
  <app-hawk-type [control]="addr3C.type" [displayErrors]="formSubmitted" [formGroup]="addr3F" [hawkTypes]="types"></app-hawk-type>
  <app-address-form [displayErrors]="formSubmitted" [formGroup]="addr3F"></app-address-form>
  <app-phone-form-row phoneFormControlName="phone" phoneNumberCssClass="col-md-4" [displayErrors]="formSubmitted" [formGroup]="addr3F"></app-phone-form-row>

  <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
    <button class="tu-button secondary tu-shadow" type="button" (click)="onBack()">{{ 'content.back' | translate }}</button>
    <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
  </div>
</form>
